export const selectIsLoading = state => state.global.isLoading;

export const selectIsModalLogoutOpen = state => state.global.isModalLogoutOpen;

export const selectIsModalAddTransaction = state =>
  state.global.isModalAddTransaction;

export const selectIsModalEditTransaction = state =>
  state.global.isModalEditTransaction;
